export default __webpack_public_path__ + "static/media/united-kingdom.b9a2ba74.png";